import Prism from 'prismjs';

(function (Prism) {
  Prism.languages.customHighlight = {
    'double-brackets': {
      pattern: /\[\[(?:[^\[\]]|\[[^\[\]]*\])*\]\]/,
    },
    'double-curly': {
      pattern: /\{\{[^\}]+\}\}/,
    },
  };
})(Prism);
